export const resolveStrategyPayload = (value = {}) => {
  if (!value || typeof value !== 'object') {
    return {};
  }

  if (value?.strategyHeadlinesAndIdentity) {
    return value;
  }

  if (value?.strategyResult && typeof value.strategyResult === 'object') {
    return value.strategyResult;
  }

  if (
    value?.results &&
    typeof value.results === 'object' &&
    !Array.isArray(value.results)
  ) {
    return value.results;
  }

  return value;
};

export const getStrategyMarkdown = (value = {}) => {
  const strategyPayload = resolveStrategyPayload(value);
  const rawDocument = strategyPayload?.strategyHeadlinesAndIdentity;

  if (typeof rawDocument === 'string') {
    return rawDocument;
  }

  return rawDocument?.markdown || strategyPayload?.markdown || '';
};
